import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type {
  UpstreamErrorLogDetail,
  UpstreamErrorLogItem,
  UpstreamErrorLogQuery,
} from '@/types/upstreamErrorLog';

export const adminUpstreamErrorLogApi = {
  list(query?: UpstreamErrorLogQuery) {
    return request<PaginatedResult<UpstreamErrorLogItem>>({
      url: '/admin/upstream-errors',
      method: 'GET',
      params: query,
    });
  },

  detail(id: string) {
    return request<UpstreamErrorLogDetail>({
      url: `/admin/upstream-errors/${id}`,
      method: 'GET',
    });
  },
};
